import { useEffect } from 'react';

const isTypingTarget = (element) => {
  if (!element) return false;
  const tag = element.tagName;
  return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || element.isContentEditable;
};

// A dialog is open somewhere: arrow keys belong to it, not to the reader.
const isDialogOpen = () => Boolean(document.querySelector('[role="dialog"]'));

/**
 * Left/right arrows move between verses, space toggles the recitation.
 * In a right-to-left reading the arrows are mirrored, so ArrowLeft advances.
 */
const useVerseShortcuts = ({ onNext, onPrevious, onTogglePlay }) => {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.metaKey || event.ctrlKey || event.altKey) return;
      if (isTypingTarget(event.target) || isDialogOpen()) return;

      switch (event.key) {
        case 'ArrowRight':
          event.preventDefault();
          onPrevious();
          break;
        case 'ArrowLeft':
          event.preventDefault();
          onNext();
          break;
        case ' ':
        case 'Spacebar':
          event.preventDefault();
          onTogglePlay();
          break;
        default:
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onNext, onPrevious, onTogglePlay]);
};

export default useVerseShortcuts;
